"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../../theme"));
const useStyles = (0, _styles.makeStyles)({
  fromTextFieldLarge: {
    display: 'none',
    [_theme.default.breakpoints.up('md')]: {
      display: 'flex'
    }
  },
  fromTextFieldMobile: {
    display: 'none',
    [_theme.default.breakpoints.down('sm')]: {
      display: 'flex'
    }
  },
  modalHeaderLabel: {
    marginBottom: '0px !important',
    color: "".concat(_theme.default.palette.white, " !important"),
    lineHeight: '150% !important',
    fontSize: '16px !important',
    [_theme.default.breakpoints.down('lg')]: {
      fontSize: '14px !important'
    }
  },
  listBoxWrapper: {
    height: 'calc(100% - 113px)',
    position: 'relative',
    boxShadow: 'none',
    borderTop: "1px solid ".concat(_theme.default.palette.border),
    borderRadius: '0'
  },
  listBoxResult: {
    display: 'block',
    width: '100%',
    minHeight: '100%',
    margin: '0',
    padding: '0',
    paddingRight: '70px',
    paddingLeft: '80px',
    borderBottom: "1px solid ".concat(_theme.default.palette.border),
    [_theme.default.breakpoints.down('sm')]: {
      paddingLeft: '20px',
      left: '0'
    },
    '& ul': {
      height: '100%',
      margin: '0',
      padding: '0',
      '& li': {
        margin: '0',
        padding: '0'
      }
    },
    '& div': {
      height: 'calc(100% - 5px)',
      margin: '0',
      padding: '0',
      left: '0'
    }
  },
  wrapText: {
    borderRadius: '0',
    '& .MuiInput-formControl': {
      border: '0',
      borderRadius: '0',
      paddingRight: '50px',
      paddingLeft: '50px',
      '& .MuiInputAdornment-root': {
        marginLeft: '0'
      },
      [_theme.default.breakpoints.down('sm')]: {
        paddingRight: '20px',
        paddingLeft: '20px'
      }
    },
    '& .Mui-error': {
      paddingRight: '50px',
      paddingLeft: '50px'
    }
  }
});
var _default = exports.default = useStyles;